export async function hostedResumeEvent(client, operationId, signal) {
    const current = (await client.getOperation(operationId, signal)).data;
    if (signal.aborted)
        return null;
    // This only reveals an existing instance, never grants a new widget execution.
    return ['created', 'action_required'].includes(current.status) && !current.providerReference
        ? 'attempt_executable'
        : 'payment_uncertain';
}
